/**
 * Rakuten Mobile Web SDK
 * Entry point for the communication modules
 */

import UserModule from "./modules/user";
import EnterpriseModule from "./modules/enterprise";
import RatingModule from "./modules/rating/rating";
import RoutingModule from "./modules/routing/routing";
import ReportingModule from "./modules/reporting/reporting";
import ResellerModule from "./modules/reseller";
import BankAccountModule from "./modules/bankAccount";
import SmbModule from "./modules/smb";
import InboxMessagesModule from "./modules/inboxMessages";
import AlertsModule from "./modules/AlertsModule";
import DistributionListModule from "./modules/bulk/distributionList";
import TemplateModule from "./modules/bulk/templates";
import ScheduledTaskModule from "./modules/bulk/scheduleTask";
import SearchModule from "./modules/search";
import ShortUrlModule from "./modules/shortUrl";
import CdrModule from "./modules/cdr";

import HelperModule from "./modules/helper";
import InvoicesModule from "./modules/invoices";

import ServicesAPI from "./modules/_super_admin/monitoring/services_api";
import AuditModule from "./modules/audit";
import ProfanityClient from "./modules/profanity";
import BlacklistClient from "./modules/blacklist";
import FileStoreModule from "./modules/filestore";
import OTTModule from "./modules/ott";
import SendMessageModule from "./modules/sendMessage";
import { removeWithExpiry } from "../../context/cachedData";

const user = new UserModule();
const enterprise = new EnterpriseModule();
const reseller = new ResellerModule();
const invoices = new InvoicesModule();

export const userModule = {
  create: user.createUser,
  update: user.update,
  createAdmin: user.createAdmin,
  refetchToken: user.refetchToken,
  resendActivationMail: user.resendActivationMail,
  getUserDetails: user.getUserDetails,
  activate: user.activateUser,
  login: user.loginUser,
  logout: user.logoutUser,
  samlLogin: user.samlLogin,
  getMfaProfile: user.getMfaProfile,
  getPasswordPolicy: user.getPasswordPolicy,
  resetPassword: user.resetPassword,
  updatePassword: user.updatePassword,
  getQuery: user.getQuery,
  requestQueryLink: user.requestQueryLink,
  activate_user: user.activate_user,
  suspend_user: user.suspend,
  retire_user: user.retire,
  unsuspend_user: user.unsuspend,
  activate_enterprise_user: user.activate_enterprise_user,
  suspend_enterprise_user: user.suspend_enterprise_user,
  retire_enterprise_user: user.retire_enterprise_user,
  unsuspend_enterprise_user: user.unsuspend_enterprise_user,
  userResendLink: user.userResendLink,
  userResendInvitationLink: user.userResendInvitationLink,
  getEnterpriseUsers: user.getEnterpriseUsers,
  getEnterpriseUsersCsvURL: user.getEnterpriseUsersCsvURL,
  fetchResellerAdminUsers: user.fetchResellerAdminUsers
};

export const resellerModule = { reseller };
export const enterpriseModule = { enterprise };
export const ratingModule = new RatingModule();
export const routingModule = new RoutingModule();
export const reportingModule = new ReportingModule();
export const bankAccountModule = new BankAccountModule();
export const smbModule = new SmbModule();
export const inboxMessagesModule = new InboxMessagesModule();
export const alertsModule = new AlertsModule();
export const distributionListModule = new DistributionListModule();
export const templateModule = new TemplateModule();
export const scheduledTaskModule = new ScheduledTaskModule();
export const shortUrlModule = new ShortUrlModule();
export const searchModule = new SearchModule();
export const cdrModule = new CdrModule();
export const auditModule = new AuditModule();
export const helperModule = {
  staticData: new HelperModule(),
};
export const profanityClient = new ProfanityClient();
export const blacklistClient = new BlacklistClient();
export const fileStoreModule = new FileStoreModule();
export const ottModule = new OTTModule();
export const invoicesModule = invoices;
export const sendMessageModule = new SendMessageModule();

// A list of items we fetch on request and store in local-storage
// we use the list to cleanup
export const STATIC_DATA_TYPES = {
  API_CHANNELS: "api_channels",
  ADMIN_USER_ROLES: "admin_user_roles",
  AUTH_SIGNATURE_METHODS: "auth_signature_methods",
  COUNTRY_CODES: "country_codes",
  CONTACT_TYPES: "contact_types",
  CURRENCY_CODES: "currency_codes",
  CREDENTIAL_TYPES: "credential_types",
  GATEWAYS: "gateways",
  PRODUCT_VALUES: "product_values",
  TWOFA_PRICING_UNITS: "twofa_pricing_units",
  NETWORKS: "networks",
  SMPP_ENCODINGS: "smpp_encodings",
  TIMEZONES: "timezones",
  TAX_REGIONS: "tax_regions",
  USER_ROLES: "user_roles",
  LANGUAGES: "languages",
  USER_STATUSES: "user_statuses",
  ADMIN_USER_STATUSES: "admin_user_statuses",
  ADMIN_LIST: "admin_list",
  ENTERPRISE_LIST: "enterprise_list",
  RESELLER_LIST: "reseller_list",
  ENTERPRISE_ACCOUNT_TYPES: "enterprise_account_types",
  ENVIRONMENT: "environment",
  ALL_NETWORKS: "all_networks",
  SMS_CONFIG: "sms_config",
};
Object.freeze(STATIC_DATA_TYPES);

export function cleanupSDKData() {
  // localStorage.clear() --> do NOT cleanup everything, we need to keep language selection
  Object.values(STATIC_DATA_TYPES).forEach((value) =>
    removeWithExpiry(value),
  );
  // remove all cookies
  document.cookie.split(";").forEach((c) => {
    document.cookie = c
      .replace(/^ +/, "")
      .replace(/=.*/, "=;expires=" + new Date().toUTCString() + ";path=/api");
  });
}

export const superAdminMonitoringModule = new ServicesAPI();
